import { Fragment } from "react";

import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import WorkOfferForm from "components/form/WorkOfferForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Offerta modificata con successo",
        errorMsg: "Errore nella modifica dell'offerta",
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function ModificaOfferta() {
    return (
        <Fragment>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Modifica Offerta</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <WorkOfferForm />

                <ButtonSave />
            </SaveContextProvider>
        </Fragment>
    );
}

export default ModificaOfferta;
